// components
import { Container } from "@mui/material";
import { BreadCrumbs } from "components/BreadCrumbs";
import TabsContent from "components/UI/TabsContent/TabsContent";
import { DecreesList } from "components/decrees/DecreesList";
import SubDecreesList from "components/decrees/DecreesList/SubDecreesList";
import { useTranslation } from "react-i18next";
import { useState } from "react";

const VALUES = {
  decrees: "decrees",
  subdecrees: "subdecrees"
};

const GetComponentByTab = ({ action }) => {
  switch (action) {
  case VALUES.decrees:
    return <DecreesList actsActive />;
  case VALUES.subdecrees:
    return <SubDecreesList actsActive />;
  default:
    return null;
  }
};

const Legislation = () => {
  const { t } = useTranslation();

  const tabsList = [ { value: VALUES.decrees, label: t("legislation") }, { value: VALUES.subdecrees, label: t("sublegislation") } ];

  const [ value, setValue ] = useState(tabsList[ 0 ]?.value);

  return (
    <Container>
      <BreadCrumbs path={t("legislation")} />
      <TabsContent tabsList={tabsList} value={value} setValue={setValue} />
      <GetComponentByTab action={value} />
    </Container>
  );
};

export default Legislation;
